import React from 'react';

export const SidebarDocIcon = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8333 10.0833H7.33333M9.16667 13.75H7.33333M14.6667 6.41667H7.33333M18.3333 6.23333V15.7667C18.3333 17.3069 18.3333 18.0768 18.0336 18.6652C17.7699 19.1826 17.3493 19.6033 16.8318 19.8669C16.2435 20.1667 15.4735 20.1667 13.9333 20.1667H8.06667C6.52652 20.1667 5.75645 20.1667 5.16819 19.8669C4.65075 19.6033 4.23005 19.1826 3.9664 18.6652C3.66667 18.0768 3.66667 17.3069 3.66667 15.7667V6.23333C3.66667 4.69319 3.66667 3.92311 3.9664 3.33486C4.23005 2.81741 4.65075 2.39672 5.16819 2.13307C5.75645 1.83333 6.52652 1.83333 8.06667 1.83333H13.9333C15.4735 1.83333 16.2435 1.83333 16.8318 2.13307C17.3493 2.39672 17.7699 2.81741 18.0336 3.33486C18.3333 3.92311 18.3333 4.69319 18.3333 6.23333Z"
      stroke="white"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
